import { injectIntl } from 'react-intl';
import { branch, compose } from 'recompose';
import { withMixpanel } from '../../Mixpanel';
import { APP_NAME, DYNAMIC_REMOTES } from '~/config/app.constants';
import globalEnv from '~/config/env';

import { withTranslationsInternal } from '../../Intl';
import { withRedux } from '../../Redux';
import { withSnowPlow } from '../../Snowplow';

import Logo from '../Shared/components/CompanyLogo';
import ConnectionCheck from './components/ConnectionCheck';
import RemoteLoadModal from './components/RemoteLoadModals';
import HeaderAction from './components/Settings';
import { CONTENT_ACCESS_TABS } from './config/constants';
import useGlobalHeaderData from './hooks/useGlobalHeaderData';
import { StyledGlobalHeaderWrapper } from './style';
import { IntlType } from '../Shared/type';

type GlobalHeaderProps = {
  intl: IntlType;
};

const GlobalHeader = ({ intl }: GlobalHeaderProps) => {
  const { pingEnabled, logoutWithCleanup, company, user, activeTab } = useGlobalHeaderData();

  return (
    <>
      {process.env.NODE_ENV === 'production' && pingEnabled && <ConnectionCheck />}
      <StyledGlobalHeaderWrapper
        data-testid={'header-dashboard'}
        data-company-name={company?.name}
        data-company-url={company?.url}
      >
        <Logo company={company} />
        <HeaderAction
          activeTab={activeTab}
          company={company}
          intl={intl}
          logout={logoutWithCleanup}
          search
          user={user}
        />
      </StyledGlobalHeaderWrapper>
      {!!user?.email && (
        <div className="modals">
          <RemoteLoadModal email={user.email} company={company} user={user} />
        </div>
      )}
    </>
  );
};

export default compose<GlobalHeaderProps, {}>(
  withTranslationsInternal({
    appName: DYNAMIC_REMOTES.LEARNER_HEADER.appName,
  }),
  withSnowPlow({
    collectorUrl: globalEnv.RXP_SVC_SNOWPLOW_INGRESS,
    namespace: APP_NAME,
  }),
  withRedux(),
  branch(() => !!globalEnv.TRACKING, withMixpanel()),
  injectIntl
)(GlobalHeader);

export { CONTENT_ACCESS_TABS };
